import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG, VIEW_PROFILE, VIEW_PROFILE_SUCCESS, VIEW_PROFILE_ERROR, PASSWORD_CHANGE } from "./actionTypes";

const initialState = {
  error: "",
  success: "",
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case VIEW_PROFILE:
      state = { ...state };
      break;
    case EDIT_PROFILE:
      state = { ...state, loading: true, };
      break;
    case PASSWORD_CHANGE:
      state = { ...state, loading: true, };
      break;
    case PROFILE_SUCCESS:
      state = { ...state, success: action.payload, loading: false };
      break;
    case PROFILE_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    case RESET_PROFILE_FLAG:
      state = { ...state, success: null };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
